import React, {  } from 'react';
import explore from '../../../src/assets/images/explore.png';
import explore1 from '../../../src/assets/images/explore1.png';
import explore2 from '../../../src/assets/images/explore2.png';
import explore3 from '../../../src/assets/images/explore3.png';
import exploree from '../../../src/assets/images/exploree.png';
import exploree1 from '../../../src/assets/images/exploree1.png';
import exploree2 from '../../../src/assets/images/ss.webp';
import exploree3 from '../../../src/assets/images/exploree3.png';
import { useNavigate } from 'react-router-dom';

const ExploreRecipe: React.FC = () => {
  const navigate = useNavigate();
  const storedCountry = localStorage.getItem('selectedCountry');

  const handleView = (id:string) => {
    navigate(`/${storedCountry}/persona/${id}`);
  };

  const persona = storedCountry === 'India' ? explore : storedCountry === 'UK' ? exploree : null;
  const persona1 = storedCountry === 'India' ? explore1 : storedCountry === 'UK' ? exploree1 : null;
  const persona2 = storedCountry === 'India' ? explore2 : storedCountry === 'UK' ? exploree2 : null;
  const persona3 = storedCountry === 'India' ? explore3 : storedCountry === 'UK' ? exploree3 : null;
  return (
    <div className="bg-white px-5 lg:p-12 mb-12 mt-1 md:mt-2">
      <h1 className="font-bold mb-8 font-sans lg:text-2xl text-lg">Explore Recipe Kit crafted just for you.</h1>
      <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 gap lg:gap-12">

        <div className="text-center mb-5 lg:mb-0 cursor-pointer" onClick={()=>handleView("united-family")}>
          {/* <img src={explore} alt="United Family" className="w-full h-full object-cover rounded-xl"/> */}
          {persona && (
          <img src={persona} alt="United Family" loading="lazy" className="w-full h-full object-cover rounded-xl cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:translate-y-[-5px]" />
        )}
          <h1 className="text-sm lg:text-lg font-semibold mt-2 lg:mt-2 font-sans">United Family</h1>
        </div>

        <div className="text-center cursor-pointer mb-5 lg:mb-0" onClick={()=>handleView("busy-professional")}>
          {/* <img src={explore1}  alt="Busy Professional" className="w-full h-full object-cover rounded-xl"/> */}
          {persona1 && (
          <img src={persona1} loading="lazy" alt="United Family" className="w-full h-full object-cover rounded-xl cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:translate-y-[-5px]" />
        )}
          <h1 className="text-sm lg:text-lg font-semibold mt-2 lg:mt-2 font-sans">Working Professional</h1>
        </div>

        <div className="text-center cursor-pointer lg:mb-0" onClick={()=>handleView("solution-seekers")}>
          {/* <img src={explore2}  alt="Solution Seekers" className="w-full h-full object-cover rounded-xl"/> */}
          {persona2 && (
          <img src={persona2} alt="Solution Seekers" loading="lazy" className="w-full h-full object-cover rounded-xl cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:translate-y-[-5px]" />
        )}
          <h1 className="text-sm lg:text-lg font-semibold mt-2 lg:mt-2 font-sans">Solution Seekers</h1>
        </div>

        <div className="text-center cursor-pointer lg:mb-0" onClick={()=>handleView("fitness-enthusiasts")}>
          {/* <img src={explore3}  alt="Fitness Enthusiasts" className="w-full h-full object-cover rounded-xl"/> */}
          {persona3 && (
          <img src={persona3} alt="Fitness Enthusiasts" loading="lazy" className="w-full h-full object-cover rounded-xl cursor-pointer transform transition-transform duration-300 hover:scale-110 hover:translate-y-[-5px]" />
        )}
          <h1 className="text-sm lg:text-lg font-semibold mt-2 lg:mt-2 font-sans">Fitness Enthusiasts</h1>
        </div>
      </div>
    </div>
  );
};

export default ExploreRecipe;
